import { PIN_ENTRY_POINT } from '@services/trackerConst';

const STORAGE_KEY = 'pin_entry_point';

/**
 * The PIN screen is reached two ways: straight after a login (hard_login), or because a live
 * session was dropped back to it — idle timeout, expired token (soft_login). Only the code that
 * drops the session knows which, so it leaves a mark here and LoginPin reads it once.
 */
export const markSoftLoginPin = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, PIN_ENTRY_POINT.SOFT_LOGIN);
  } catch (e) {
    // sessionStorage can throw in private mode; tracking accuracy is not worth breaking logout
  }
};

export const consumePinEntryPoint = () => {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return value === PIN_ENTRY_POINT.SOFT_LOGIN
      ? PIN_ENTRY_POINT.SOFT_LOGIN
      : PIN_ENTRY_POINT.HARD_LOGIN;
  } catch (e) {
    return PIN_ENTRY_POINT.HARD_LOGIN;
  }
};
